import {
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output,
} from '@angular/core'
import { MatProgressBar } from '@angular/material/progress-bar'
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog'
import { FormSearchComponent } from '../../../shared/components/form-search/form-search.component'
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component'
import { TableListComponent } from '../../../shared/components/table-list/table-list.component'
import {
  PagedContactTypeResponse,
} from '../../../core/models/contact-type.model'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import { TableListSelectComponent } from '../../../shared/components/table-list-select/table-list-select.component'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { EmployeeService } from '../../../core/services/employee/employee/employee.service'
import { FormClientSearchComponent } from "../../../shared/components/form-client-search/form-search.component";
import { FormOperationConsultantSearchComponent } from "../../../shared/components/form-operation-consultant-search/form-operation-consultant-search.component";
import { responseDefaultForm } from '../../../shared/utils/utils'

@Component({
  selector: 'modal-employee-consultant-operational',
  imports: [
    FormSearchComponent,
    MatProgressBar,
    PaginationComponent,
    TableListComponent,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatIcon,
    TableListSelectComponent,
    MatButton,
    MatProgressSpinner,
    FormClientSearchComponent,
    FormOperationConsultantSearchComponent
  ],
  templateUrl: './modal-employee-consultant-operational.component.html',
  styleUrl: './modal-employee-consultant-operational.component.scss',
  standalone: true,
  providers: [EmployeeService],
})
export class ModalEmployeeConsultantOperationalComponent implements OnInit {
  constructor(
    private employeeService: EmployeeService,
    private dialogRef: MatDialogRef<ModalEmployeeConsultantOperationalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.multiSelect = data.multiSelect ?? false
    if (this.multiSelect) {
      this.listSelected = data.item
    } else {
      this.selected = data.item
    }
  }

  multiSelect = false

  @Output() responseSingle = new EventEmitter()
  @Output() responseMulti = new EventEmitter()

  listSelected: any[] = []
  selected: any = { id: -1, description: '' }

  listSearch: any = [
    {
      id: 'nome',
      description: 'Nome',
      type: 'string',
      visible: true
    },
    {
      id: 'cpf',
      description: 'Cpf',
      type: 'string',
      visible: true,
    },
    {
      id: 'matricula',
      description: 'Matricula',
      type: 'string',
      visible: true
    },
  ]
  page = 1
  rows = 10
  numberRows = 0
  itemsList: any[] = []
  loading = false
  searchForm: any = { search: false, model: {} }
  inputSearch = ''
  columns: any[] = [
    {
      keyColumn: 'action',
      key: { select: true },
      description: '',
    },
    {
      keyColumn: 'name',
      key: 'nome',
      description: 'Nome',
    },
    {
      keyColumn: 'cpf',
      key: 'cpf',
      description: 'Cpf',
    },
    {
      keyColumn: 'email',
      key: 'email',
      description: 'Email',
    },
  ]
  screen = 'status operação'

  ngOnInit() {
    this.getListItems()
  }

  close() {
    this.dialogRef.close()
  }

  search(event: any) {
    if (event.search) {
      this.searchForm = {
        search: true,
        model: this.createModel(event.data),
      }
    }
    this.page = 1
    this.uploadList(!event.search ? 'new' : '')
  }

  createModel(element: any) {
    const model: any = {
    }
    for (let i = 0; i < this.listSearch.length; i++) {
      const item = this.listSearch[i]
      model[item.id] =
        item.id == element.type
          ? element.search
          : responseDefaultForm(item.type)
    }
    return model
  }


  pageChanged(page: number) {
    this.page = page
    this.uploadList()
  }

  uploadList(type = '') {
    if (type == 'new') {
      this.searchForm = { search: false, model: {} }
    }
    if (this.searchForm.search) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  treatResponse(response: any) {
    const list = []
    if (response.data) {
      for (const item of response.data) {
        list.push(item)
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }

  getListItems() {
    this.loading = true
    this.employeeService
      .listPagedEmployeeConsultantOperate(this.page, this.rows)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => { },
        complete: () => {
          this.loading = false
        },
      })
  }

  searchListItems() {
    this.loading = true
    this.employeeService
      .searchPagedEmploeyeeOperate(this.page, this.rows, this.searchForm.model)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => { },
        complete: () => {
          this.loading = false
        },
      })
  }

  selectItem(event: any) {
    if (this.multiSelect) {
      const index = this.listSelected.findIndex((ele) => ele.id == event.id)
      if (index > -1) {
        this.listSelected.splice(index, 1)
      } else {
        this.listSelected.push(event)
      }
    } else {
      if (this.selected.id == event.id) {
        this.selected = { id: -1, description: '' }
      } else {
        this.selected = event
      }
    }
  }

  checkForm() {
    if (this.selected.id >= 0 || this.listSelected.length > 0) {
      return true
    } else {
      return false
    }
  }

  removeSelection() {
    if (this.multiSelect) {
      this.responseMulti.emit({ remove: true })
    } else {
      this.responseSingle.emit({ remove: true })
    }
    this.close()
  }

  confirmSelection() {
    if (this.multiSelect) {
      this.responseMulti.emit({ remove: false, selection: this.listSelected })
    } else {
      this.responseSingle.emit({ remove: false, selection: this.selected })
    }
    this.close()
  }

  editItem(event: any) {
  }

  deleteItem(event: any) {
  }
}
